import { Guttagekonto } from '@/domain/mitarbeiter/features/guttagekonto/shared/entities/Guttagekonto';
import { mapAbwesenheitsGrundToIcon } from '@/domain/mitarbeiter/shared/utils/mapAbwesenheitToIcon';
import { GetMitarbeiterGuttagekontoByIdDocument } from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';
import dayjs from 'dayjs';

export function useGuttagekonto(
  ids: string[],
  jahr: number,
): {
  guttagekonto: Guttagekonto;
} {
  const von = dayjs()
    .year(jahr)
    .startOf('year')
    .format('YYYY-MM-DD')
    .toString();
  const bis = dayjs().year(jahr).endOf('year').format('YYYY-MM-DD').toString();

  const { data, error } = useSuspenseQuery(
    GetMitarbeiterGuttagekontoByIdDocument,
    {
      variables: {
        mitarbeiterId: ids,
        jahr: jahr,
        von: von,
        bis: bis,
      },
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  );
  const result = data?.mitarbeiter_mitarbeiterByIds[0];
  if (error || !data) {
    Sentry.captureException(error);
    return {
      guttagekonto: null,
    };
  }
  const abwesenheiten = result.guttagekonto.abwesenheiten;

  const guttagekontoResult: Guttagekonto = {
    mitarbeiter: {
      uid: result.uid,
      vorname: result.vorname,
      nachname: result.nachname,
    },
    jahr: result.guttagekonto.jahr,
    ausgezahlteGuttage: result.guttagekonto.ausgezahlteGuttage,
    gegebeneGuttage: result.guttagekonto.gegebeneGuttage,
    genommeneGuttage: result.guttagekonto.genommeneGuttage,
    istStand: result.guttagekonto.istStand,
    uebertragAusVorjahr: result.guttagekonto.uebertragAusVorjahr,
    abwesenheiten:
      abwesenheiten.map((abwesenheit) => ({
        uid: abwesenheit.uid,
        datum: abwesenheit.datum,
        faktor: abwesenheit.faktor,
        dauer: abwesenheit.dauer,
        bemerkung: abwesenheit.bemerkung,
        grund: {
          markierung: abwesenheit.grund.markierung,
          value: abwesenheit.grund.value,
        },
        abwesenheitsgrundIcon: mapAbwesenheitsGrundToIcon(
          abwesenheit.grund.value,
        ),
      })) || [],
  };

  return {
    guttagekonto: guttagekontoResult,
  };
}
